import { replace } from 'lodash';
import React, { useCallback, useState } from 'react';
import FormTextField from '../../../controls/FormTextField';
import SimpleValueView from '../../../controls/ValueViews/SimpleValueView';
import EntityField from '../internal/EntityField';
import useHelpNote from '../../../utils/Translations/useHelpNote';
const TextField = ({ noLabel = false, isMultiline = false, columns, inputContainer = false, getRequired, isReadOnly = false, required = false, hasPlaceholderOnEmptyValue = false, isEditable = false, label = '', maxLength, normalize, placeholder, emptyPlaceHolder, validate, draggable, name, className, infoMessage, infoMessageAlign, infoMessageClassName, labelIconPosition, labelIcon, errorMessage, dataCy, tooltipTitle, ...rest }) => {
    const getHelpNoteTooltipTitle = useHelpNote();
    const [stateError, setError] = useState('');
    const resolvedTooltipTitle = tooltipTitle || getHelpNoteTooltipTitle(label || placeholder || '');
    const _validate = useCallback(value => {
        if (validate && validate(value)) {
            return validate(value);
        }
        if (!value && required) {
            return 'Required';
        }
        if (maxLength && value && value.length > maxLength) {
            const error = `Max length is ${maxLength}`;
            if (value.length === maxLength) {
                setError(error);
                return '';
            }
            return error;
        }
        setError('');
        return '';
    }, [required, validate, maxLength]);
    return (<EntityField columns={columns} name={name} normalize={normalize} required={getRequired || required} {...rest} validate={_validate}>
      {(editable, { meta, ...field }, { disabled, required }) => !isReadOnly && (editable || isEditable) ? (<FormTextField animateTitle={!noLabel} className={className} disabled={disabled} draggable={draggable} inputContainer={inputContainer} label={label} meta={{
        ...meta,
        error: meta.error || stateError,
    }} noLabel={noLabel} placeholder={placeholder || label} {...field} dataCy={dataCy} errorMessage={errorMessage} infoMessage={infoMessage} infoMessageAlign={infoMessageAlign} infoMessageClassName={infoMessageClassName} labelIcon={labelIcon} labelIconPosition={labelIconPosition} maxLength={maxLength} required={required} tooltipTitle={resolvedTooltipTitle}/>) : (<SimpleValueView className={className} isMultiline={isMultiline} label={label} noLabel={noLabel} value={((rest === null || rest === void 0 ? void 0 : rest.type) === 'password'
        ? replace(field.input.value, /./g, '*')
        : field.input.value) ||
        (hasPlaceholderOnEmptyValue
            ? emptyPlaceHolder || placeholder
            : null)}/>)}
    </EntityField>);
};
export default TextField;
